import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Section, Eyebrow, H2, Lead, GlassCard } from "../components/site/Primitives";
import { useAuth } from "../lib/auth";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function Login() {
  const nav = useNavigate();
  const { loginEmail, startGoogle } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await loginEmail(f.email, f.password); toast.success("Welcome back."); nav("/portal"); }
    catch { toast.error("Invalid credentials."); }
  };
  return (
    <Section className="pt-40 max-w-xl">
      <Eyebrow>Sign In</Eyebrow>
      <H2>Access the 220 Inc. portals.</H2>
      <Lead className="mt-4">Sign in with Google or email — your account adapts to your role.</Lead>

      <GlassCard className="p-8 mt-10">
        <button onClick={startGoogle} className="btn-ghost w-full justify-center" data-testid="login-google">
          <ShieldCheck size={16} /> Continue with Google
        </button>
        <div className="my-6 flex items-center gap-4 text-xs text-white/40"><div className="flex-1 h-px bg-white/10" /> OR <div className="flex-1 h-px bg-white/10" /></div>
        <form onSubmit={submit} className="space-y-4" data-testid="login-email-form">
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.18em] text-white/50 mb-2">Email</span>
            <input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}
              className="w-full bg-[#0e0e10] border border-white/10 px-3 py-3 text-white text-sm focus:outline-none focus:border-gold"
              data-testid="login-email" />
          </label>
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.18em] text-white/50 mb-2">Password</span>
            <input type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
              className="w-full bg-[#0e0e10] border border-white/10 px-3 py-3 text-white text-sm focus:outline-none focus:border-gold"
              data-testid="login-password" />
          </label>
          <button type="submit" className="btn-primary w-full justify-center" data-testid="login-submit">Sign In <ArrowRight size={14} /></button>
        </form>
        <div className="mt-6 text-sm text-white/60">
          New to 220 Inc.? <Link to="/register" className="text-gold">Create an account</Link>
        </div>
      </GlassCard>
    </Section>
  );
}
